import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as SystemHttp from '../../../../services/api/https/system/system.http'

export const MODAL_NAME = {
  CUSTOMER: 'CUSTOMER',
  ASSOC_CUSTOMER_LOG_OPERATOR: 'ASSOC_CUSTOMER_LOG_OPERATOR',
  ASSOC_CUSTOMER_ENTERPRISE: 'ASSOC_CUSTOMER_ENTERPRISE',
  CUSTOMER_STRETCH: 'CUSTOMER_STRETCH',
  DELIVERY_ROUTE: 'DELIVERY_ROUTE',
  LOCAL_MOVEMENT: 'LOCAL_MOVEMENT',
  NONE: 'NONE',
}

export const MENU_ITEMS_NAMES = ['Editar', 'Remover da Lista']

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL: 'INITIAL',
  LOADING_CUSTOMERS: 'Carregando clientes',
  REMOVE: 'Removendo da lista',
}

const INITIAL_STATE = {
  newCustomer: {
    id: undefined,
    razaoSocial: '',
    nomeFantasia: '',
    cnpj: '',
    address: '',
    district: '',
    number: '',
    makeParcialReturn: false,
    actived: false,
    city_id: undefined,
    uf_id: undefined,
  },
  selectedClient: null,
  isLoading: true,
  loadingMessage: LOAD_MESSAGE.INITIAL,
  customers: [],
  globalFilter: '',
  modalHandler: {
    modalData: null,
    modalSelected: MODAL_NAME.NONE,
  },
  errorMessage: null,
}

export default function useClienteInconsistencia() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    // Helper
    function setModalSelected(modalName, modalData = null) {
      setState(prevState => {
        prevState.modalHandler.modalSelected = modalName
        prevState.modalHandler.modalData = modalData
        return { ...prevState }
      })
    }

    return {
      // Actions
      getCustomers(selectedTp) {
        SystemHttp.getClientsWithInconsistency()
          .then(customers =>
            setState(prevState => ({
              ...prevState,
              customers: customers,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(error =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(error),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      deleteClientFromList(clientId) {
        SystemHttp.deleteClientsWithInconsistencyFromList(clientId)
          .then(customers =>
            setState(prevState => ({
              ...prevState,
              customers: customers,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      modalIsOpen(modalName) {
        return state.modalHandler.modalSelected === modalName
      },

      closeModal() {
        setState(prevState => {
          prevState.modalHandler.modalSelected = MODAL_NAME.NONE
          prevState.modalHandler.modalData = null
          return { ...prevState }
        })
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.LOADING_CUSTOMERS }))
      },

      onInputFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onBtnNovoCliente(selectedTp) {
        if (selectedTp === 0)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione o Operador Logístico' }))
        else setModalSelected(MODAL_NAME.CUSTOMER)
      },

      onModalClienteSave(customer) {
        setState(prevState => {
          const index = prevState.customers.findIndex(cus => cus.id === customer.id)
          if (index !== -1) prevState.customers[index] = customer
          else prevState.customers.push(customer)
          prevState.modalHandler.modalSelected = MODAL_NAME.NONE
          prevState.modalHandler.modalData = null
          return { ...prevState }
        })
      },

      onMenuItemClicked(item, cliente) {
        switch (item) {
          case 'Editar':
            setModalSelected(MODAL_NAME.CUSTOMER, cliente)
            break
          case 'Remover da Lista':
            setState(prevState => ({
              ...prevState,
              selectedClient: cliente,
              loadingMessage: LOAD_MESSAGE.REMOVE,
            }))
            break
          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
